<template>
  <v-overlay v-model="appLoader.visible">
    <v-card light>
      <v-card-text>
        <span class="body-1">{{ appLoader.text }}</span>
        <v-progress-circular indeterminate color="primary" class="ma-3"/>
      </v-card-text>
    </v-card>
  </v-overlay>
</template>

<script>
import hasAppLoader from '@/mixins/hasAppLoader';
import { mapState } from 'vuex';

export default {
  name: 'AppLoader',
  mixins: [hasAppLoader],

  computed: {
    ...mapState(['appLoader']),
  },
};
</script>

<style scoped>

</style>
